"use strict";module.exports=({collections:s})=>s?s.nodes.map((s=>Object.assign(Object.assign({},s),{inventoryItems:s.inventoryItems.nodes.map((s=>Object.assign({},s)))}))):null;
//# sourceMappingURL=index.js.map
